import { DeviceHasPassedBox } from "components/DeviceHasPassedBox/DeviceHasPassedBox"
import { TakeNoteBox } from "components/TakeNoteBox/TakeNoteBox"

import { DeviceSetup, Examination, TestData } from "graphql/types"

type FunctionTestProps = {
  data: TestData
  // eslint-disable-next-line no-unused-vars
  setData: (data: TestData) => void
  deviceSetup: DeviceSetup[]
  examination: Examination | undefined
}

export const FunctionTest = (props: FunctionTestProps) => {
  const { data, setData, deviceSetup, examination } = props

  return (
    <>
      <TakeNoteBox data={data} setData={setData} name="Funktionstest " />
      {examination && (
        <DeviceHasPassedBox
          data={data}
          setData={setData}
          deviceSetup={deviceSetup}
          examination={examination}
        />
      )}
    </>
  )
}
